import { SearchOutlined, UserOutlined,CalendarOutlined,EnvironmentOutlined} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Popover, Tag, Modal } from 'antd';
import { NdoeImage, NdoeResponsiveTable } from '../../components/ndoe';
import axios from 'axios';
import config from '../../config';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import DetailPointure from '../ventes/detailPointureVente/DetailPointure';

const MouvementRetour = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const scroll = { x: 500 };
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const user = useSelector((state) => state.user?.currentUser);
    const [pointure, setPointure] = useState('');
    const [openPointure, setOpenPointure] = useState('');
    const [idVariant, setvariant] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 15,
    });
    const [totalItems, setTotalItems] = useState('');



        const showModal = (e,p) => {
          setOpenPointure(true);
          setvariant(e)
          setPointure(p)
        };

    
      const columns = [
        { title: '#', 
          dataIndex: 'id', 
          key: 'id', 
          render: (text, record, index) => {
            const pageSize = pagination.pageSize || 15;
            const pageIndex = pagination.current || 1;
            return (pageIndex - 1) * pageSize + index + 1;
          }
        },
        {
          title: 'image',
          dataIndex: 'img',
          key: 'img',
          render: (text, record) => (
            <NdoeImage src={record.img} alt="Article" size="lg" />
          ),
        },
        {
          title: 'Marque',
          dataIndex: 'nom_marque',
          key: 'nom_marque',
          render: (text, record) => {
            return <Tag color={"blue"}>{text}</Tag>;
          },
        },
        {
            title: 'Pointure',
            dataIndex: 'taille',
            key: 'taille',
            render: (text, record) => (
              <div>
                <Popover title={`Voir l'historique de pointure ${record.taille}`} trigger="hover">
                  <Tag color="blue" onClick={() => showModal(record.id_varianteProduit, record.id_taille)}>
                    {text}
                  </Tag>
                </Popover>
              </div>
            ),
          },        
        {
          title: 'Client',
          dataIndex: 'nom_client',
          key: 'nom_client',
          render: (text, record) => {
            return <Tag color={"green"}>{text}</Tag>;
          },
        },
        {
          title: 'Commune',
          dataIndex: 'nom_commune',
          key: 'nom_commune',
          render : (text,record)=>(
            <div>
                <Tag color={'green'}><EnvironmentOutlined style={{ marginRight: "5px" }} /> {text}</Tag>
            </div>
          )
        },
        {
          title: 'Livreur',
          dataIndex: 'livreur',
          key: 'livreur',
          render : (text,record)=>(
            <Popover content={`Voir toutes les livraisons de ${text}`} placement="top">
              <div style={{cursor: 'pointer'}} onClick={()=> showModalLivreur(record.id_livreur)}>
                <Tag color={'green'}><UserOutlined style={{ marginRight: "5px" }} /> {text}</Tag>
              </div>
            </Popover>
          )
        },
        {
          title: 'Date & Heure',
          width: 176,
          dataIndex: 'date_mouvement',
          key: 'date_mouvement',
          sorter: (a, b) => a.date_mouvement - b.date_mouvement,
          sortDirections: ['descend', 'ascend'],
          render: (text) => (
            <Tag color={'blue'} icon={<CalendarOutlined />}>
              {moment(text).format('DD-MM-yyyy HH:mm')}
            </Tag>
          ),
        },
          {
            title: 'Type mouv',
            dataIndex: 'type_mouvement',
            key: 'type_mouvement',
            render: (text, record) => {
              const color = record.id_type_mouvement === 5 ? 'red' : 'green';
              return <Tag color={color}>{text}</Tag>;
            },
          },
          {
            title: 'Qté',
            dataIndex: 'quantite',
            key: 'quantite',
            sorter: (a, b) => a.quantite - b.quantite,
            sortDirections: ['descend', 'ascend'],
            render: (quantite) => (
              <Tag color={quantite > 0 ? 'green' : 'red'}>{quantite}</Tag>
            ),
        },
        {
          title: 'Qté stock',
          dataIndex: 'stock',
          key: 'stock',
          sorter: (a, b) => a.stock - b.stock,
          sortDirections: ['descend', 'ascend'],
          render: (stock) => (
            <Tag color={stock > 0 ? 'green' : 'red'}>{stock}</Tag>
          ),
      },
      ];

      const showModalLivreur = (e) => {
        navigate(`/mouvementOne/${e}`)
      };


        const fetchData = async (page = currentPage, size = pageSize) => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/mouvementRetour?page=${page}&pageSize=${size}`);
            setData(data.data);
            setTotalItems(data.total)
            setLoading(false)
          } catch (error) {
            console.log(error);
          }
        };


      useEffect(() => {
        fetchData(currentPage, pageSize);
      }, [currentPage, pageSize]);

      const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination({
          current: pagination.current,
          pageSize: pagination.pageSize,
        });
        fetchData(pagination.current, pagination.pageSize);
      };
  
   const filteredData = data?.filter((item) =>
      item.type_mouvement?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.nom_marque?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.nom_commune?.toLowerCase().includes(searchValue.toLowerCase()) || 
      item.nom_client?.toLowerCase().includes(searchValue.toLowerCase()) || 
      item.livreur?.toLowerCase().includes(searchValue.toLowerCase())
    )
    
    return (
    <>
        <div className="products">
            <div className="product-container">
                <div className="product-bottom">
                    <div className="product-bottom-top">
                        <div className="product-bottom-left">
                          <Input
                              type="search"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                              placeholder="Recherche..."
                              className="product-search"
                          />  
                        </div>
                        <div className="product-bottom-right">
                        </div>
                    </div>
                    <div className="rowChart-row-table">
                        <NdoeResponsiveTable 
                          columns={columns} 
                          data={filteredData} 
                          loading={loading} 
                          scroll={scroll} 
                          bordered
                          size="middle"
                          pagination={{
                              current: currentPage,
                              pageSize: pageSize,
                              total: totalItems,
                              onChange: handleTableChange,
                            }}
                          onChange={handleTableChange} 
                        />
                    </div>
                    <Modal
                      title=""
                      centered
                      open={openPointure}
                      onCancel={() => setOpenPointure(false)}
                      width={1100}
                      footer={[]}
                    >
                      <DetailPointure idVariant={idVariant} idTaille={pointure}/>
                    </Modal>
                </div>
            </div>
        </div>
    </>
  )
}

export default MouvementRetour